import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Field, View } from '@components';
import TreeSet from './TreeSet';
import { setValoresSelecionados } from '@ducks/indicadoresVariaveisAmbiente';
import styled from 'styled-components';

const Fields = styled(View)`
  padding-right: 15px;
  flex: 2;
`;

export default function SelectTable({ data }) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (data.valores && data.valores !== '') {
      dispatch(setValoresSelecionados(data.valores.split(',')));
    }
  }, []);

  return (
    <Fields>
      <Field label="Valores">
        <TreeSet treeData={data.set} />
      </Field>
    </Fields>
  );
}
